import { render, staticRenderFns } from "./user-avatar-cropper-modal.vue?vue&type=template&id=13829e9c"
import script from "./user-avatar-cropper-modal.vue?vue&type=script&lang=js"
export * from "./user-avatar-cropper-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports